import { getNotifications, markNotificationsRead, type Notification } from './notifications-api';
import { useData } from './useData';

const KIND_ICO: Record<string, string> = {
  advance_paid: '💰',
  pay_overdue: '⏰',
  pay_due_soon: '📅',
};

// Метка времени в БД — UTC (datetime('now')); показываем во времени завода (Asia/Almaty).
function fmtTime(at: string): string {
  if (!at) return '';
  const iso = at.includes('T') ? at : at.replace(' ', 'T') + (at.endsWith('Z') ? '' : 'Z');
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return at;
  return d.toLocaleString('ru-RU', {
    timeZone: 'Asia/Almaty',
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Лента внутренних уведомлений. onOpenDeal — открыть карточку сделки по клику.
export function NotificationsPanel({ onOpenDeal }: { onOpenDeal?: (id: number) => void }) {
  const { data, refresh } = useData('notifications', getNotifications);
  const items: Notification[] = data?.notifications ?? [];
  const unread = data?.unread ?? 0;

  async function markRead() {
    await markNotificationsRead();
    await refresh();
  }

  if (!data) return null;
  if (items.length === 0) return null; // без событий блок не показываем

  return (
    <div className="glass pad" style={{ marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
        <b>🔔 Уведомления</b>
        {unread > 0 && <span className="chip red">{unread} новых</span>}
        <button
          className="btn ghost sm"
          style={{ marginLeft: 'auto' }}
          disabled={unread === 0}
          onClick={markRead}
        >
          Отметить прочитанным
        </button>
      </div>
      {items.map((n) => (
        <div
          className="row"
          key={n.id}
          style={{
            cursor: n.deal_id && onOpenDeal ? 'pointer' : 'default',
            opacity: n.unread ? 1 : 0.6,
          }}
          onClick={() => n.deal_id && onOpenDeal?.(n.deal_id)}
        >
          <span style={{ fontSize: 18, width: 26 }}>{KIND_ICO[n.kind] ?? '•'}</span>
          <div className="grow">
            <div className="rname">
              {n.unread && (
                <span className="chip red" style={{ marginRight: 6 }}>
                  new
                </span>
              )}
              {n.title}
            </div>
            {n.body && <div className="rmeta">{n.body}</div>}
          </div>
          <div className="rmeta mono">{fmtTime(n.at)}</div>
        </div>
      ))}
    </div>
  );
}
